import { useDispatch } from 'react-redux';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { closeDialog } from '../../store/modules/dialog';
import { useWhaleSpaceDataSliceSelector } from '../../store/modules/whaleSpaceData';
import { isDevicePC } from '../../utils/util';
import styled, { css } from 'styled-components';
import Dialog from './Dialog';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import { useGenConfirmPromise } from '../confirm/Confirm';
import { requestWhaleSpaceLogout } from '../../extApis/whaleSpaceApi';
import UserInfoDialogMobile from './mobile/UserInfoDialogMobile';

const DialogBody = styled.div`
  display: flex;
  width: 322px;
  height: 243px; //not included Dialog showTitleSeperateLine 1px
  flex-flow: column;
  box-sizing: border-box;
  align-items: center;
`;

const InfoField = styled.div`
  display: flex;
  width: 290px;
  height: 160px;
  flex-flow: column;
  margin: 8px 16px 28px 16px;
`;

const InfoItem = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  align-items: center;
`;

const InfoItemName = styled.div`
  width: 40px;
  margin-right: 16px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #96999c;
`;

const InfoItemValue = styled.div`
  width: 234px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #2f3133;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
`;

function UserInfoDialog({ isShow }) {
  const { t } = useTranslation();
  const appDataSlice = useAppDataSliceSelector();
  const whaleSpaceSlice = useWhaleSpaceDataSliceSelector();
  const isPCView = isDevicePC(appDataSlice.deviceType);
  const confirmPromise = useGenConfirmPromise();

  const closeDispatch = useDispatch();
  const onClickCloseBtn = () => {
    closeDispatch(closeDialog());
  };

  const onClickLogout = async () => {
    try {
      const confirm = await confirmPromise({
        message: t('UserInfoDialog.LogoutMessage')
      });
      if (confirm) {
        const res = await requestWhaleSpaceLogout();
        if (res) location.reload();
        else throw new Error();
      }
    } catch (error) {
      alert('Logout failed.');
    }
  };

  return (
    <>
      {isPCView === true ? (
        <Dialog
          title={t('UserInfoDialog.Title')}
          showCloseBtn
          showTitleSeperateLine
          onClickCloseBtn={onClickCloseBtn}
          isShow={isShow}>
          <DialogBody>
            <InfoField>
              <InfoItem>
                <InfoItemName>{t('UserInfoDialog.ID')}</InfoItemName>
                <InfoItemValue title={whaleSpaceSlice.userEmail}>
                  {whaleSpaceSlice.userEmail}
                </InfoItemValue>
              </InfoItem>
              <InfoItem>
                <InfoItemName>{t('UserInfoDialog.Name')}</InfoItemName>
                <InfoItemValue title={whaleSpaceSlice.userFullName}>
                  {whaleSpaceSlice.userFullName}
                </InfoItemValue>
              </InfoItem>
              <InfoItem>
                <InfoItemName>{t('UserInfoDialog.Space')}</InfoItemName>
                <InfoItemValue title={whaleSpaceSlice.userSpaceName}>
                  {whaleSpaceSlice.userSpaceName}
                </InfoItemValue>
              </InfoItem>
              <InfoItem>
                <InfoItemName>{t('UserInfoDialog.Position')}</InfoItemName>
                <InfoItemValue title={whaleSpaceSlice.userType}>
                  {whaleSpaceSlice.userType}
                </InfoItemValue>
              </InfoItem>
            </InfoField>
            <Button
              cssExt={css`
                width: 140px;
                height: 30px;
                padding: 5px 6px 6px;
                border-radius: 2px;
                border: solid 1px #b1b6bb;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 13px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #2f3133;
              `}
              onClick={onClickLogout}>
              {t('UserInfoDialog.Logout')}
            </Button>
          </DialogBody>
        </Dialog>
      ) : (
        <UserInfoDialogMobile
          isShow={isShow}
          onClickCloseBtn={onClickCloseBtn}
          onClickLogout={onClickLogout}></UserInfoDialogMobile>
      )}
    </>
  );
}

export default UserInfoDialog;
